
import { motion } from "framer-motion";
import { LogIn } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

export const Navigation = () => {
  const navigate = useNavigate();

  return (
    <nav className="fixed w-full top-0 z-50 bg-background/80 backdrop-blur-sm border-b">
      <div className="container mx-auto px-4 h-16 flex items-center justify-between">
        <motion.div 
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          className="flex items-center"
        >
          <img 
            src="/lovable-uploads/42b04185-d3b3-4a55-807a-8e213c72d6cb.png" 
            alt="QNINJA Logo" 
            className="h-8"
          />
        </motion.div>
        <motion.div
          initial={{ opacity: 0, x: 20 }}
          animate={{ opacity: 1, x: 0 }}
        >
          <Button onClick={() => navigate("/login")} variant="default">
            <LogIn className="mr-2" />
            Sign In
          </Button>
        </motion.div>
      </div>
    </nav>
  );
};
